
import axios from 'axios';
import apiConfig from './apiConfig.js';

const apiService = axios.create({
    baseURL: apiConfig.apiUrl,
});

export async function fetchData(controller, params, token) {
    try {

        const response = await apiService.get(`/${controller}${params}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}


//fechdata including branch
export async function fetchData1(controller, params1, token) {
    try {
        const url = `/${controller}${params1}`;
        console.log('Request URL:', url); // Log the URL for debugging

        const response = await apiService.get(url, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            },
        });
        return response.data; // Return the data from the response
    } catch (error) {
        if (error.response) {
            // Server responded with an error status
            console.error('Server Error:', error.response.data);
            console.error('Status Code:', error.response.status);
        } else if (error.request) {
            // Request was sent but no response received
            console.error('No response received:', error.request);
        } else {
            // Other errors (e.g., client-side)
            console.error('Unexpected Error:', error.message);
        }
        throw error; // Re-throw the error to propagate it upstream
    }
}

export async function fetchEventincomeExpenseData(controller, param1, param2, param3, token) {
    const boolParam = param3 === true ? 'true' : 'false'; // Convert to lowercase string for URL
    const url = `/${controller}${param1}${param2}/${boolParam}`;

    try {
        const response = await apiService.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("API request failed:", error);
        throw error;
    }
}
export async function fetchEventincomeExpenseDataFull(controller, param1, param2,token) {
  
    const url = `/${controller}${param1}${param2}`;

    try {
        const response = await apiService.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("API request failed:", error);
        throw error;
    }
}
export async function fetchDataAccountsIncomeExpense(controller, param1, param2, token) {
    const boolParam = param2 === true ? 'true' : 'false'; // Convert to lowercase string for URL
    const url = `/${controller}${param1}/${boolParam}`;

    try {
        const response = await apiService.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("API request failed:", error);
        throw error;
    }
}

export async function fetchDatalist(controller, params, params2, token) {
    try {

        const response = await apiService.get(`/${controller}${params}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}
export async function fetchDataActive(controller, token) {
    try {

        const response = await apiService.get(`/${controller}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}
export async function postData(controller, data, token) {
    try {
        const response = await apiService.post(`/${controller}`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header

            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}
export async function postDataNew(controller, route, data, token) {
    try {
        const response = await apiService.post(`/${controller}/${route}`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        // Handle the error and log it
        console.error('API call failed:', error.response || error.message);
        throw error;
    }
}
export async function postLogin(controller, data) {
    try {
        const response = await apiService.post(`/${controller}`, data);
        return response.data;
    } catch (error) {
        console.error("Network or Server Error:", error.message);
        console.error("Error Details:", error);
        throw error;
    }
}



export async function updateData(controller, id, data, token) {
    try {
        const response = await apiService.put(`/${controller}/${id}`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            // Request made and server responded
            console.error('Error response:', error.response.data);  // Log the error details
            console.error('Error status:', error.response.status);
            console.error('Error headers:', error.response.headers);
        } else if (error.request) {
            // The request was made but no response was received
            console.error('Error request:', error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.error('General Error:', error.message);
        }
        throw error;
    }
}


export async function updateDataNew(controller, route, id, tmpType, data, token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/UpdateParticipants/${tmpType}`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error('Error response:', error.response.data);
            console.error('Error status:', error.response.status);
            console.error('Error headers:', error.response.headers);
        } else if (error.request) {
            console.error('Error request:', error.request);
        } else {
            console.error('General Error:', error.message);
        }
        throw error;
    }
}


export async function deleteData(controller, id, token) {
    try {
        const response = await apiService.delete(`/${controller}/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}
export async function deleteData1(controller, id, type, token) {
    try {
        const response = await apiService.delete(`/${controller}/${id}/${type}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function deleteData2(controller, id, type, token) {
    try {
        const response = await apiService.delete(`/${controller}/${id}/${type}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}
export async function deleteIncomeExpenseData(controller, type, id, token) {
    try {
        // Based on the type of deletion, use the correct route
        const route = type === 'participants' 
            ? `/${controller}/deleteParticipant/${id}` 
            : `/${controller}/deleteIncomeExpense/${id}`;
        
        const response = await apiService.delete(route, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}


export async function activateData(controller, id, token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/activate`, null, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function SyncData(controller, id, token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/update`, null, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function SyncReprint(controller, id, userId, token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/${userId}/update`, null, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}
